"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.object.keys");require("core-js/modules/web.dom.iterable");
























































































var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { searchData: { productionCompanyName: '', hardwareModuleId: '', otaVersion: '', firmwareType: 5, page: 1, rows: 10 }, //搜索表单
      pageData: { page: 1, rows: 10, total: 0, pages: 1 }, //分页数据
      showDialog: false, //是否显示新增||编辑弹窗
      showCopy: false, //是否显示复制下载地址弹窗
      tableColumns: [{ prop: 'productionCompanyName', label: '硬件厂商名称' }, { prop: 'hardwareModuleCode', label: '小腿板模块型号' }, { prop: 'otaVersion', label: '小腿板固件版本号' }, { prop: 'createTime', label: '上传时间', formatter: _formatter.dateFormatter }, { prop: 'remark', label: '备注' }], //表格信息
      list: [], //表格数据
      versionForm: { id: 0, otaVersion: '', productionCompanyId: '', hardwareModuleId: '', remark: '', url: '', md5: '', firmwareDownloadType: '' }, //新增版本信息表单
      versionFormRule: { otaVersion: [{ required: true, message: '请填写小腿板固件版本号', trigger: ['blur', 'change'] }], productionCompanyId: [{ required: true, message: '请选择硬件厂商名称', trigger: ['blur', 'change'] }], hardwareModuleId: [{ required: true, message: '请选择小腿板型号', trigger: ['blur', 'change'] }], url: [{ required: true, message: '请上传固件版本文件', trigger: ['blur', 'change'] }], firmwareDownloadType: [{ required: true, message: '请选择下载方式', trigger: ['blur', 'changer'] }] }, //新增版本信息表单验证规则
      companyList: [], //厂商列表
      filterHardwareModuleList: [], //顶部筛选硬件模块型号列表
      hardwareModuleList: [], //硬件型号列表
      currentVerion: '', //当前正在编辑的版本信息
      moduleCode: '' //小腿板型号code
    };}, mounted: function mounted() {this.initPage();}, methods: { /**
                                                                     * 页面初始化
                                                                     */initPage: function initPage() {this.fetchVersionInfoList();this.fetchHardwareModuleDownList(true);this.fetchProductionCompanyDorpdownList();}, /**
                                                                                                                                                                                                                       * 获取固件版本列表
                                                                                                                                                                                                                       */
    fetchVersionInfoList: function fetchVersionInfoList() {var _this = this;
      var params = Object.assign({}, this.searchData);
      this.getData('/api/versionInfo', params, function (res) {
        _this.list = res.list;
        _this.pageData.page = res.pageNum;
        _this.pageData.total = res.total;
      });
    },

    /**
        * 获取所有厂商列表
        */
    fetchProductionCompanyDorpdownList: function fetchProductionCompanyDorpdownList() {var _this2 = this;
      this.getData('/api/productionCompany/getDownList', {}, function (res) {
        _this2.companyList = res;
      });
    },

    /**
        * 获取硬件型号下拉列表
        */
    fetchHardwareModuleDownList: function fetchHardwareModuleDownList() {var _this3 = this;var isFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.getData(isFilter ? '/api/hardwareModule/getDownList?type=5' : '/api/hardwareModule/getDownList?type=5&productionCompanyId=' + this.versionForm.productionCompanyId, {}, function (res) {
        if (isFilter) {
          _this3.filterHardwareModuleList = res;
        } else {
          _this3.hardwareModuleList = res;
        }
      });
    },

    /**
        * 重置
        */
    onClickReset: function onClickReset() {
      this.$set(this.searchData, 'productionCompanyName', '');
      this.$set(this.searchData, 'hardwareModuleId', '');
      this.$set(this.searchData, 'otaVersion', '');
      this.$set(this.searchData, 'page', 1);
      this.fetchVersionInfoList();
    },

    /**
        * 每页size-change
        */
    handleSizeChange: function handleSizeChange(val) {
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.fetchVersionInfoList();
    },

    /**
        * 页码-change
        */
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchData.page = val;
      this.fetchVersionInfoList();
    },

    /**
        * 新增||编辑弹窗关闭
        */
    onDialogClose: function onDialogClose() {var _this4 = this;
      this.$nextTick(function () {
        Object.keys(_this4.versionForm).forEach(function (key) {
          _this4.$set(_this4.versionForm, key, key == 'id' ? 0 : '');
        });
        _this4.$refs.versionForm.clearValidate();
        _this4.currentVerion = '';
        _this4.moduleCode = '';
      });
      this.showDialog = false;
    },

    /**
        * 编辑
        */
    onClickUpdate: function onClickUpdate(row) {
      this.showDialog = true;
      this.currentVerion = Object.assign({}, row);
      this.$set(this.versionForm, 'id', row.id);
      this.$set(this.versionForm, 'otaVersion', row.otaVersion);
      this.$set(this.versionForm, 'productionCompanyId', row.productionCompanyId);
      this.$set(this.versionForm, 'hardwareModuleId', row.hardwareModuleId);
      this.$set(this.versionForm, 'remark', row.remark);
      this.$set(this.versionForm, 'url', row.url);
      this.$set(this.versionForm, 'md5', row.md5);
      this.$set(this.versionForm, 'firmwareDownloadType', row.firmwareDownloadType + '');
      this.moduleCode = row.hardwareModuleCode;
      this.fetchHardwareModuleDownList();
    },

    /**
        * 复制下载地址
        */
    onClickCopyLink: function onClickCopyLink(row) {
      this.showCopy = true;
      this.currentVerion = Object.assign({}, row);
    },

    /**
        * 删除
        */
    onClickDelete: function onClickDelete(row) {var _this5 = this;
      this.$confirm('确定删除当前小腿板版本？', '提示', { type: 'warning' }).then(function (res) {
        //删除版本
        _this5.delData('/api/versionInfo', { id: row.id }, function (res) {
          _this5.fetchVersionInfoList();
        });
      }).catch(function (err) {

      });
    },

    /**
        * 硬件厂商名称-change
        */
    onProductionCompanyIdChange: function onProductionCompanyIdChange() {
      this.$set(this.versionForm, 'hardwareModuleId', '');
      this.fetchHardwareModuleDownList();
    },

    /**
        * 小腿板型号-change
        */
    onHarewareModuleIdChange: function onHarewareModuleIdChange(e) {
      if (e) {
        for (var i = 0; i < this.hardwareModuleList.length; i++) {
          var element = this.hardwareModuleList[i];
          if (parseInt(element.id) == parseInt(e)) {
            this.moduleCode = element.moduleCode;
            break;
          }
        }
      } else {
        this.moduleCode = '';
      }
    },

    /**
        * 上传文件之前的的钩子
        */
    onBeforeUpload: function onBeforeUpload() {
      if (!this.versionForm.otaVersion) {
        this.$message({
          type: 'error',
          message: '请先填写小腿板固件版本号' });

        return false;
      }
      if (!this.versionForm.hardwareModuleId) {
        this.$message({
          type: 'error',
          message: '请选择小腿板型号' });

        return false;
      }
      return true;
    },

    /**
        * 固件版本文件上传成功回调
        */
    onFileSuccess: function onFileSuccess(res) {
      if (parseInt(res.errCode) == 0) {
        //成功
        this.$set(this.versionForm, 'url', res.data.url);
        this.$set(this.versionForm, 'md5', res.data.md5);
      } else {
        //失败
        this.$message({
          type: 'error',
          message: res.errMsg });

      }
    },

    /**
        * 新增||保存版本信息
        */
    onSubmitVersionInfo: function onSubmitVersionInfo() {var _this6 = this;
      this.$refs.versionForm.validate(function (valid) {
        if (valid) {
          var params = Object.assign({}, _this6.versionForm);
          params.firmwareType = 5;
          if (params.id) {
            //编辑
            params.createTime = _this6.currentVerion.createTime;
            _this6.putData('/api/versionInfo', params, function (res) {
              _this6.onDialogClose();
              _this6.fetchVersionInfoList();
            });
          } else {
            //新增
            delete params['id'];
            _this6.postData('/api/versionInfo', params, function (res) {
              _this6.onDialogClose();
              _this6.$set(_this6.searchData, 'page', 1);
              _this6.fetchVersionInfoList();
            });
          }
        }
      });
    },

    /**
        * 复制弹窗关闭
        */
    onCopyDialogClose: function onCopyDialogClose() {var _this7 = this;
      this.$nextTick(function () {
        _this7.currentVerion = '';
      });
      this.showCopy = false;
    },

    /**
        * 复制下载地址
        */
    copyLink: function copyLink() {
      var url = document.querySelector('#copyObj');
      url.select(); // 选择对象
      document.execCommand('Copy');
      this.showCopy = false;
    } } };exports.default = _default;